import styled from 'styled-components';

export default styled.div`
  padding: 0px ${(props) => props.theme.grid.gap};

  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    display: none;
  }
  hr {
    border-top: 1px solid ${(props) => props.theme.gray2};
  }
  h3 {
    font-family: ${(props) => props.theme.standoutFontFamily};
    font-size: 1rem;
    text-transform: uppercase;
    margin: 20px 0 10px 0;
  }
`;
